import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "artifact" }
const _hoisted_2 = {
  key: 0,
  class: "artifact"
}
const _hoisted_3 = {
  class: "left-column",
  style: {"width":"45%"}
}
const _hoisted_4 = { class: "control" }
const _hoisted_5 = {
  key: 0,
  class: "material-symbols-outlined"
}
const _hoisted_6 = {
  key: 1,
  class: "material-symbols-outlined"
}
const _hoisted_7 = { class: "with-tooltip" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "tooltip" }
const _hoisted_10 = {
  key: 0,
  class: "edit-mainstat"
}
const _hoisted_11 = ["value"]
const _hoisted_12 = ["step"]
const _hoisted_13 = {
  key: 1,
  class: "mainstat",
  style: {"margin":"1px 0"}
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { style: {"width":"55%"} }
const _hoisted_17 = { class: "artifact-substat" }
const _hoisted_18 = { class: "right" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["value", "disabled"]
const _hoisted_21 = { class: "right" }
const _hoisted_22 = ["onUpdate:modelValue", "step"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  class: "left-column",
  style: {"width":"45%"}
}
const _hoisted_25 = {
  key: 0,
  class: "score"
}
const _hoisted_26 = { class: "control" }
const _hoisted_27 = {
  key: 0,
  type: "button"
}
const _hoisted_28 = {
  key: 0,
  class: "material-symbols-outlined",
  style: {"color":"yellow"}
}
const _hoisted_29 = {
  key: 1,
  class: "material-symbols-outlined"
}
const _hoisted_30 = { class: "with-tooltip" }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = { class: "tooltip" }
const _hoisted_33 = {
  class: "mainstat",
  style: {"margin":"1px 0"}
}
const _hoisted_34 = { style: {"width":"55%"} }
const _hoisted_35 = { class: "artifact-substat" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArtifactSetSelect = _resolveComponent("ArtifactSetSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.control == 'editable')
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEditing = !_ctx.isEditing))
                  }, [
                    (_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, " edit_off "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, " edit "))
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    class: "artifact-icon",
                    src: _ctx.artifactImgSrc,
                    alt: _ctx.displayName(_ctx.copiedArtifact.name),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.artifactIconOnClick()))
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.displayName(_ctx.copiedArtifact.name)), 1)
                ]),
                (_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.copiedArtifact.mainStat) = $event)),
                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStatOptions, (option) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: option,
                            value: option
                          }, _toDisplayString(_ctx.displayName(option)), 9, _hoisted_11))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.copiedArtifact.mainStat]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.copiedArtifact.mainStatValue) = $event)),
                        step: _ctx.statStep(_ctx.copiedArtifact.mainStat),
                        min: "0",
                        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
                      }, null, 40, _hoisted_12), [
                        [_vModelText, _ctx.copiedArtifact.mainStatValue]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.displayName(_ctx.copiedArtifact.mainStat).replace(/%$/, '') + '+' +
                _ctx.displayStatValue(_ctx.copiedArtifact.mainStat,
                  _ctx.copiedArtifact.mainStatValue)), 1)),
                (_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("select", {
                        class: "star",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.copiedArtifact.rarity) = $event)),
                        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.starOnChange && _ctx.starOnChange(...args)))
                      }, _cache[11] || (_cache[11] = [
                        _createElementVNode("option", { value: "5" }, " ★5 ", -1),
                        _createElementVNode("option", { value: "4" }, " ★4 ", -1)
                      ]), 544), [
                        [_vModelSelect, _ctx.copiedArtifact.rarity]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(_ctx.copiedArtifact.rarity), (dummy) => {
                        return (_openBlock(), _createElementBlock("img", {
                          class: "star",
                          src: "images/star.png",
                          key: dummy
                        }))
                      }), 128))
                    ]))
              ]),
              _createElementVNode("td", _hoisted_16, [
                _createElementVNode("table", _hoisted_17, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.copiedArtifact.subStats, (subStat, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        (_ctx.isEditing)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("td", _hoisted_18, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": ($event: any) => ((subStat.name) = $event),
                                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subStatOptions, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option,
                                      value: option,
                                      disabled: _ctx.subStatOptionDisabled(option, subStat.name)
                                    }, _toDisplayString(_ctx.displayName(option)), 9, _hoisted_20))
                                  }), 128))
                                ], 40, _hoisted_19), [
                                  [_vModelSelect, subStat.name]
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_21, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((subStat.value) = $event),
                                  step: _ctx.statStep(subStat.name),
                                  min: "0",
                                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
                                }, null, 40, _hoisted_22), [
                                  [_vModelText, subStat.value]
                                ])
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(_ctx.displayName(subStat.name).replace(/%$/, '') + '+' + _ctx.displayStatValue(subStat.name, subStat.value)), 1))
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("table", {
          key: 1,
          class: "artifact",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectOnClick()))
        }, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_24, [
                (_ctx.score)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(Math.round(_ctx.score * 10) / 10), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.control == 'selectable')
                    ? (_openBlock(), _createElementBlock("button", _hoisted_27, [
                        (_ctx.selected)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, " select_check_box "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_29, " check_box_outline_blank "))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("img", {
                    class: "artifact-icon",
                    src: _ctx.artifactImgSrc,
                    alt: _ctx.displayName(_ctx.copiedArtifact.name)
                  }, null, 8, _hoisted_31),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.displayName(_ctx.copiedArtifact.name)), 1)
                ]),
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.displayName(_ctx.copiedArtifact.mainStat).replace(/%$/, '') + '+' +
                _ctx.displayStatValue(_ctx.copiedArtifact.mainStat,
                  _ctx.copiedArtifact.mainStatValue)), 1),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(_ctx.copiedArtifact.rarity), (dummy) => {
                    return (_openBlock(), _createElementBlock("img", {
                      class: "star",
                      src: "images/star.png",
                      key: dummy
                    }))
                  }), 128))
                ])
              ]),
              _createElementVNode("td", _hoisted_34, [
                _createElementVNode("table", _hoisted_35, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.copiedArtifact.subStats, (subStat, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.displayName(subStat.name).replace(/%$/, '') + '+' + _ctx.displayStatValue(subStat.name, subStat.value)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_ArtifactSetSelect, {
        visible: true,
        index: 1,
        "artifact-set": _ctx.artifact.setname,
        "artifact-set-masters": _ctx.artifactSetMasters,
        cat_id: _ctx.artifact.cat_id,
        "onUpdate:artifactSet": _ctx.updateArtifactSet
      }, null, 8, ["artifact-set", "artifact-set-masters", "cat_id", "onUpdate:artifactSet"])
    ], 512), [
      [_vShow, _ctx.isListShow]
    ])
  ]))
}